export const INTEGRATIONS_CONFIG = [
  {
    id: "163ddc56-1b32-490f-a17f-c9f051ca2486",
    key: "sienge",
    title: "Sienge",
    subtitle: "Construção Civil",
    text: "Software de gestão para construção civil que centraliza processos financeiros, operacionais e administrativos em um único sistema.",
    icon: "https://123zap-us-east-1.s3.amazonaws.com/assets/163ddc56-1b32-490f-a17f-c9f051ca2486.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/sienge",
  },
  {
    id: "92675b11-a206-4437-b111-a78782b40bca",
    key: "elitesoft",
    title: "EliteSoft",
    subtitle: "ERP Provedor",
    text: "ERP completo para provedores de internet, com foco em automação de processos, financeiro, suporte técnico e gestão de clientes.",
    icon: "https://123zap-us-east-1.s3.amazonaws.com/assets/92675b11-a206-4437-b111-a78782b40bca.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/elitesoft",
  },
  {
    id: "ee253ff4-f24a-464b-a909-25754e2b624f",
    key: "controllr",
    title: "Controllr ISP",
    subtitle: "ERP Provedor",
    text: "Plataforma de gestão para provedores de internet que organiza operações, financeiro, contratos, boletos e controle de rede.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/ee253ff4-f24a-464b-a909-25754e2b624f.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/controllr-isp",
  },
  {
    id: "37e2494b-57b3-4ae4-8603-1a4ec65b27e7",
    key: "hubsoft",
    title: "HubSoft",
    subtitle: "ERP Provedor",
    text: "Sistema de gestão para provedores de internet com recursos para financeiro, clientes, chamados, boletos e integrações de rede.",
    icon: "https://123zap-us-east-1.s3.amazonaws.com/assets/37e2494b-57b3-4ae4-8603-1a4ec65b27e7.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/hubsoft",
  },
  {
    id: "bf7f6bba-a114-48af-9e92-7ae146160925",
    key: "sgp",
    title: "SGP",
    subtitle: "ERP Provedor",
    text: "Solução de gestão para provedores de internet que centraliza cadastros, contratos, financeiro, suporte técnico e documentos.",
    icon: "https://123zap-us-east-1.s3.amazonaws.com/assets/bf7f6bba-a114-48af-9e92-7ae146160925.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/sgp",
  },
  {
    id: "49ed3283-f1d7-4f8c-8813-6d5b266f1b8f",
    key: "ixc",
    title: "IXC Soft",
    subtitle: "ERP Provedor",
    text: "Solução de gestão para provedores de internet que centraliza cadastros, contratos, financeiro, suporte técnico e documentos.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/49ed3283-f1d7-4f8c-8813-6d5b266f1b8f.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/sgp",
  },
  {
    id: "7a9f6b8e-22a2-4a48-a7b7-0d29d3a5e6c4",
    key: "bemobi",
    title: "Bemobi (7AZ)",
    subtitle: "Integração Adicional",
    text: "Credencial adicional para enriquecimento de faturas com PIX e link de PDF via 7AZ.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/7a9f6b8e-22a2-4a48-a7b7-0d29d3a5e6c4.png",
    features: ["Enriquecimento de faturas"],
    tag: "Disponível",
    route: "/integracoes/bemobi",
  },
  {
    id: "4a9987df-4eeb-4574-8e91-e4a39c4146e2",
    key: "voalle",
    title: "Voalle",
    subtitle: "ERP Provedor",
    text: "Plataforma de gestão para provedores com foco em faturamento, contratos, cobrança e integrações com serviços de telecom.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/4a9987df-4eeb-4574-8e91-e4a39c4146e2.jpg",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/voalle",
  },
  {
    id: "a1a3493b-494b-4889-a8b4-d3812f66bcf6",
    key: "mksolutions",
    title: "MK Solutions",
    subtitle: "ERP Provedor",
    text: "Sistema de gestão para provedores com foco em faturamento, contratos, cobrança e gestão de clientes.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/a1a3493b-494b-4889-a8b4-d3812f66bcf6.jpg",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/mksolutions",
  },
  {
    id: "83cbe03b-c078-4fc5-85dc-eba7a84960e4",
    key: "atlaz",
    title: "Atlaz",
    subtitle: "ERP Provedor",
    text: "Sistema de gestão para provedores com foco em faturamento, cobrança e gestão de clientes.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/83cbe03b-c078-4fc5-85dc-eba7a84960e4.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/atlaz",
  },
  {
    id: "22fc9cda-5534-4c20-a230-1c9beb24c6e4",
    key: "cobrefacil",
    title: "Cobre Fácil",
    subtitle: "Plataforma de Cobrança",
    text: "Plataforma completa de cobranças com gestão de boletos, Pix, cartão de crédito e assinaturas recorrentes.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/22fc9cda-5534-4c20-a230-1c9beb24c6e4.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/cobrefacil",
  },
  {
    id: "b8c52fde-96e3-4070-8fbc-5a9764990c2b",
    key: "asaas",
    title: "Asaas",
    subtitle: "Integração de Cobrança",
    text: "Plataforma de cobranças e pagamentos com gestão completa de boletos, Pix, cartão de crédito e assinaturas recorrentes.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/b8c52fde-96e3-4070-8fbc-5a9764990c2b.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/asaas",
  },
  {
    id: "830402e7-3992-44ae-9a1b-eca333383796",
    key: "receitanet",
    title: "Receita NET",
    subtitle: "ERP Provedor",
    text: "Sistema completo de gestão para provedores de internet, oferecendo soluções integradas para controle de assinantes, faturamento, atendimento ao cliente e gestão de rede.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/830402e7-3992-44ae-9a1b-eca333383796.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/receitanet",
  },
  {
    id: "2cba40c4-fa16-4faf-aa13-7dfbbfeed807",
    key: "ispfy",
    title: "ISPFY",
    subtitle: "ERP Provedor",
    text: "Integração com a API do ISPFY para consulta de faturas e cobrança.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/2cba40c4-fa16-4faf-aa13-7dfbbfeed807.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/ispfy",
  },
  {
    id: "dc7b8ab0-6fde-46bb-bf42-5fd1e4f77a29",
    key: "lhisp",
    title: "LH ISP",
    subtitle: "ERP Provedor",
    text: "Integração com a API de parceiros da LH ISP para consulta de faturas e dados de cobrança terceirizada.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/dc7b8ab0-6fde-46bb-bf42-5fd1e4f77a29.png?v=20260514-2238",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/lhisp",
  },
  {
    id: "f0c4c83c-2b6d-4d57-90aa-4b4c421b6d8e",
    key: "superlogica",
    title: "Superlógica Assinaturas",
    subtitle: "ERP Provedor",
    text: "Integração com a API de assinaturas da Superlógica para consulta de clientes e faturas.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/f0c4c83c-2b6d-4d57-90aa-4b4c421b6d8e.png?v=20260514-2226",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/superlogica",
  },
  {
    id: "d2f4c0a9-6f6a-4e88-a2c8-8f20a57a7bc1",
    key: "ssotica",
    title: "ssOtica",
    subtitle: "ERP Varejo Óptico",
    text: "Integração com a API Consultiva ssOtica para consulta de contas a receber (faturas) em múltiplas filiais.",
    icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/d2f4c0a9-6f6a-4e88-a2c8-8f20a57a7bc1.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/ssotica",
  },
  {
    id: "f5erp",
    key: "f5erp",
    title: "F5 ERP",
    subtitle: "ERP Provedor",
    text: "Integração com a API do F5 ERP para consulta de boletos e contas a receber por vencimento.",
    icon: "/assets/f5erp-logo.jpeg",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/f5erp",
  },
  {
    id: "mkauth",
    key: "mkauth",
    title: "MK-Auth",
    subtitle: "ERP Provedor",
    text: "Integração com a API do MK-Auth para consulta de títulos (faturas) com linha digitável e PIX.",
    icon: "/assets/mkauth-logo.png",
    features: ["Consulta de faturas"],
    tag: "Disponível",
    route: "/integracoes/mkauth",
  },
  // {
  //   id: "fa614ff0-0ec1-48d0-bb6c-b99f6cd0b94b",
  //   key: "efi",
  //   title: "Efi",
  //   subtitle: "Banco",
  //   text: "Integração financeira com o banco Efi para autenticação segura e operações via API Pix.",
  //   icon: "https://123zap-697481710632.s3.us-east-1.amazonaws.com/assets/fa614ff0-0ec1-48d0-bb6c-b99f6cd0b94b.png",
  //   features: ["Consulta de faturas"],
  //   tag: "Disponível",
  //   route: "/integracoes/efi",
  // },
];

export function normalizeIntegrationValue(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

const INTEGRATION_KEY_ALIASES = {
  controllrisp: "controllr",
  controllr: "controllr",
  hubsoft: "hubsoft",
  sgp: "sgp",
  elitesoft: "elitesoft",
  sienge: "sienge",
  ixcsoft: "ixc",
  ixc: "ixc",
  bemobi7az: "bemobi",
  bemobi: "bemobi",
  "7az": "bemobi",
  mksolutions: "mksolutions",
  atlaz: "atlaz",
  atlas: "atlaz",
  efi: "efi",
  voalle: "voalle",
  cobrefacil: "cobrefacil",
  asaas: "asaas",
  receitanet: "receitanet",
  ispfy: "ispfy",
  lhisp: "lhisp",
  superlogicaassinaturas: "superlogica",
  superlogica: "superlogica",
  ssotica: "ssotica",
  sotica: "ssotica",
  f5erp: "f5erp",
  f5: "f5erp",
  mkauth: "mkauth",
};

export function resolveIntegrationKey(value) {
  const normalizedValue = normalizeIntegrationValue(value);
  if (!normalizedValue) return null;

  const directConfig = INTEGRATIONS_CONFIG.find((integration) =>
    [
      integration.id,
      integration.key,
      integration.title,
    ]
      .filter(Boolean)
      .some((candidate) => normalizeIntegrationValue(candidate) === normalizedValue),
  );

  if (directConfig?.key) return directConfig.key;
  if (directConfig?.title) return INTEGRATION_KEY_ALIASES[normalizeIntegrationValue(directConfig.title)] || null;

  return INTEGRATION_KEY_ALIASES[normalizedValue] || null;
}

export function resolveIntegrationConfig(value) {
  const key = resolveIntegrationKey(value);
  if (!key) return null;

  return (
    INTEGRATIONS_CONFIG.find(
      (integration) =>
        integration.key === key ||
        normalizeIntegrationValue(integration.title) === key,
    ) || null
  );
}

export function resolveIntegrationTitle(value) {
  return resolveIntegrationConfig(value)?.title || value;
}

export function resolveIntegrationIcon(value) {
  return resolveIntegrationConfig(value)?.icon || null;
}
